<script setup lang="ts">
import { computed, useI18n } from '#imports'

export interface YscCamperCardPriceDisplayProps {
  bookingDailyPrice?: {
    value: number
    currency: string
  }
  bookingTotalPrice?: {
    value: number
    currency: string
  }
  bookingTotalPriceBeforeDiscount?: {
    value: number
    currency: string
  }
  startingPrice?: {
    value: number
    currency: string
  }
}

const props = defineProps<YscCamperCardPriceDisplayProps>()

const { n, t } = useI18n()

const formatPrice = ({ value, currency }: { value: number, currency: string }) => {
  return n(value, { style: 'currency', currency, currencyDisplay: 'symbol', maximumFractionDigits: 0 })
}

const formattedDailyPrice = computed(() => {
  if (!props.bookingDailyPrice) return undefined

  return t('camper_card.daily_price', { amount_string: formatPrice(props.bookingDailyPrice) })
})

const formattedTotalPrice = computed(() => {
  if (!props.bookingTotalPrice) return undefined

  return t('camper_card.total_price', { amount_string: formatPrice(props.bookingTotalPrice) })
})

const formattedBeforeDiscountPrice = computed(() => {
  if (!props.bookingTotalPriceBeforeDiscount) return undefined

  return formatPrice(props.bookingTotalPriceBeforeDiscount)
})

const formattedStartingPrice = computed(() => {
  if (!props.startingPrice) return undefined

  return formatPrice(props.startingPrice)
})
</script>

<template>
  <template v-if="formattedDailyPrice">
    <p class="font-semibold">
      {{ formattedDailyPrice }}
    </p>
    <p class="text-xs">
      <span class="line-through">{{ formattedBeforeDiscountPrice }}</span> {{ formattedTotalPrice ?? '' }}
    </p>
  </template>
  <template v-else-if="formattedStartingPrice">
    <p class="text-xs">
      {{ $t('camper_card.starting_price') }}
    </p>
    <p class="font-semibold">
      {{ formattedStartingPrice }}
    </p>
  </template>
</template>
